import gql from 'graphql-tag'
import { PER_PAGE_MAXIMUM } from '@/utils/constants'

export const CompanyHasCustomFields = gql`
  fragment CompanyHasCustomFields on Company {
    customFields(first: 1000, page: 1) {
      data {
        title
        id
        description
        fieldType
        appliesTo
        customFieldOptions {
          id
          displayOrder
          value
          label: value # used for listing purposes
        }
      }
    }
  }
`

export const CompanyQuery = gql`
  query company($companyId: ID!) {
    company(id: $companyId) {
      id
      settings {
        staffingAgencyManagesWorker
      }
      organisations(first: ${PER_PAGE_MAXIMUM}) {
        data {
          id
          divisions(first: ${PER_PAGE_MAXIMUM}) {
            paginatorInfo {
              count
            }
            data {
              id
            }
          }
        }
        paginatorInfo {
          count
        }
      }
      ...CompanyHasCustomFields
    }
  }
  ${CompanyHasCustomFields}
`
